<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-image-area"
    ></vuse-section-definition>

    <v-container fluid>
      <v-row justify="center" align="center">
        <v-col cols="12" class="text-right mb-5">
          <v-btn
              class="btn-add-templates"
              @click="addTemplate"
          >
            Add Templates
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="white mx-1">
        <v-row class="mt-4 ml-4">
          <v-col cols="2">
            <v-text-field
                label="ID"
                placeholder="Enter the ID of the template"
                filled
                v-model="id"
                @input="debounceInputByID"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
                label="Name"
                placeholder="Enter the name of the template"
                filled
                v-model="name"
                @input="debounceInput"
            ></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="2">
            <v-select
                :items="listTemplateSize"
                item-text="name"
                item-value="id"
                filled
                label="Size"
                v-model="size"
                @input="debounceInputSearchSize"
            ></v-select>
          </v-col>
          <v-col class="d-flex" cols="2">
            <v-select
                :items="listThemes"
                item-text="name"
                item-value="id"
                filled
                label="Theme"
                v-model="theme"
                @input="debounceInputSearchTheme"
            ></v-select>
          </v-col>
        </v-row>
        <v-col cols="12" class="mt-n2">
          <div class="text-center" v-if="loading">
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
          </div>
          <div v-else-if="!loading && templates?.length > 0">
            <v-data-table
                :headers="headers"
                :items="templates"
                :sort-by="['id']"
                :sort-desc="true"
                :footer-props="{
               'items-per-page-options': [10, 20, 30, 40, 50,-1]
               }"
                :page.sync="pagination.page"
                :itemsPerPage.sync="pagination.itemsPerPage"
                :server-items-length.sync="totalTemplate"
                @update:page="changePage"
                @update:items-per-page="changeItemsPerPage"
                @pagination="changePagination"
            >
              <template v-slot:item.img_url="{ item }">
                <div v-if="item.template_sizes && item.template_sizes.length >0">
                  <img
                      :src="item.template_sizes[0]?.pivot.thumbnail ?  item.template_sizes[0]?.pivot.thumbnail :item.template_sizes[0]?.pivot.img_url"
                      aspect-ratio="1.7" style="width: 200px; margin-top: 8px">
                </div>
              </template>
              <template v-slot:item.theme="{ item }">
                <div v-for="(element,index) in item.theme" :key="index">{{ element.name }}<span
                    v-if="index < item.theme.length-1">,</span></div>
              </template>
              <template v-slot:item.link="{ item }">
                <div v-if="item.template_sizes && item.template_sizes.length >0">
                  <div v-for="(el,el_index) in item.template_sizes" :key="el_index">
                    <a :href="redirectLink(item.id,el.id)" target="_blank"> {{ redirectLink(item.id, el.id) }}</a>
                  </div>
                </div>
              </template>
              <template v-slot:item.free="{ item }">
                <div v-if="item.free ==1">Free</div>
              </template>
              <template v-slot:item.created_at="{ item }">
                <div>{{ formatDate(item.created_at) }}</div>
              </template>
              <template v-slot:item.updated_at="{ item }">
                <div v-if="item.psd_template_file">{{ formatDate(item.updated_at) }}</div>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="viewItem(item.id)">
                  mdi-eye
                </v-icon>
                <v-icon small class="mr-2" @click="editItem(item.id)" title="edit Template">
                  mdi-pencil
                </v-icon>

                <v-icon small class="mr-2" @click="addFont(item.id)"
                        v-if="item.template_sizes[0]?.pivot.json_template_file"
                        title="add Font Template">
                  mdi-wrench
                </v-icon>
                <v-icon small class="mr-2" @click="copyItem(item.id)">mdi-content-copy</v-icon>
                <v-icon small @click="deleteItem(item.id)">
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </div>

        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import {
  DELETE_TEMPLATE, GET_LIST_TEMPLATE,
  GET_TEMPLATE_BY_COPY
} from "@/store/modules/template";
import {mapGetters} from "vuex";
import {GET_LIST_TEMPLATE_SIZE} from "@/store/modules/template_size";
import {debounce} from "debounce";
import {GET_LIST_TEMPLATE_THEMES} from "@/store/modules/themes";
import Vue from "vue";
import Toasted from 'vue-toasted';
import {formatDateTime} from "@/utils/time";

Vue.use(Toasted)

export default {

  components: {},
  data() {
    return {
      page: "Templates",
      breadcrumbs: [
        {
          text: "Templates Setting",
          disabled: true,
        },
        {
          text: "Templates",
          disabled: false,
        },
      ],
      headers: [
        {text: "ID", value: "id", align: "start"},
        {text: "Image", sortable: false, value: "img_url"},
        {text: "Edit Link", value: "link"},
        {text: "Name", value: "name"},
        {text: "Theme", value: "theme"},
        {text: "Type", value: "free"},
        {text: "Created Time", value: "created_at"},
        {text: "Psd Uploaded Time", value: "updated_at"},
        {text: "Actions", value: "actions", sortable: false},
      ],
      url: '',
      url_page: '',
      template_id: '',
      name: '',
      size: '',
      theme: '',
      loading: false,
      pagination: {
        page: 1,
        itemsPerPage: 20,
      },
      id: null
    };
  },
  computed: {
    ...mapGetters({
      templates: "templates",
      listTemplateSize: "listTemplateSize",
      listThemes: "listThemes",
      totalTemplate: "totalTemplate"
    })
  },
  watch: {
    '$route': {
      immediate: true,
      deep: true,
      handler(to) {
        const itemsPerPage = parseInt(to.query.itemsPerPage) || this.pagination.itemsPerPage;
        const page = parseInt(to.query.page) || this.pagination.page;
        this.pagination.itemsPerPage = itemsPerPage;
        this.pagination.page = page;
      }
    }
  },
  async mounted() {
    this.url = process.env.VUE_APP_API_URL
    this.url_page = process.env.VUE_APP_PAGE_URL
    await this.$store.dispatch(GET_LIST_TEMPLATE_SIZE);
    await this.$store.dispatch(GET_LIST_TEMPLATE_THEMES);
    await this.setQueryParam()
    await this.params()
  },
  methods: {
    setQueryParam(id=null) {
      let path = ''
      if (id) {
        path = `/template_setting/templates/edit_template/${id}`
      }
      this.$router.push({
        path: path,
        query: {
          template_id: this.$route.query.template_id ? this.$route.query.template_id : this.template_id,
          name: this.$route.query.name ? this.$route.query.name : this.name,
          template_size_id: this.$route.query.template_size_id ? this.$route.query.template_size_id : this.size,
          theme_id: this.$route.query.theme_id ? this.$route.query.theme_id : this.theme,
          page: this.pagination.page,
          itemsPerPage: this.pagination.itemsPerPage
        }
      });
    },
    changePage(page) {
      this.$store.commit('SET_LIST_TEMPLATE', {data: {data: {data: []}}});
      this.pagination.page = page;
      this.setQueryParam()
      this.params()
    },
    changeItemsPerPage(itemsPerPage) {
      this.$store.commit('SET_LIST_TEMPLATE', {data: {data: {data: []}}});
      this.pagination.itemsPerPage = itemsPerPage;
      this.setQueryParam()
      this.params()
    },
    changePagination(pagination) {
      this.pagination.page = pagination.page;
      this.setQueryParam()
    },
    formatDate(date) {
      return formatDateTime(date, 'YYYY/MM/DD HH:mm:ss')
    },
    params() {
      this.loading = true
      let params = {
        template_id: this.$route.query.template_id ? this.$route.query.template_id : this.template_id,
        name: this.$route.query.name ? this.$route.query.name : this.name,
        template_size_id: this.$route.query.template_size_id ? this.$route.query.template_size_id : this.size,
        theme_id: this.$route.query.theme_id ? this.$route.query.theme_id : this.theme,
        limit: this.pagination.itemsPerPage,
        page: this.pagination.page
      };
      this.$store.dispatch(GET_LIST_TEMPLATE, params).then((data) => {
        if (data && data.data) {
          this.loading = false
        }
      });
    },
    replaceOrder() {
      this.$router.replace({
        query: {
          template_id: this.template_id,
          name: this.name,
          template_size_id: this.size,
          theme_id: this.theme,
          page: this.pagination.page,
          itemsPerPage: this.pagination.itemsPerPage
        }
      })
    },
    debounceInputByID: debounce(function (e) {
      this.template_id = e;
      this.loading = true
      this.replaceOrder();
      this.params();
    }, 200),
    debounceInput: debounce(function (e) {
      this.name = e;
      this.loading = true
      this.replaceOrder();
      this.params();
    }, 200),
    debounceInputSearchSize: debounce(function (e) {
      this.size = e
      this.loading = true
      this.replaceOrder();
      this.params();
    }, 200),
    debounceInputSearchTheme: debounce(function (e) {
      this.theme = e
      this.loading = true
      this.replaceOrder();
      this.params();
    }, 200),

    viewItem(id) {
      if (this.pagination.itemsPerPage != -1) {
        this.setQueryParam(id)
      } else {
        this.$router.push("/template_setting/templates/edit_template/" + id)
      }

    },
    editItem(id) {
      if (this.pagination.itemsPerPage != -1) {
        this.setQueryParam(id)
      } else {
        this.$router.push("/template_setting/templates/edit_template/" + id)
      }


    },
    copyItem(id) {
      this.$store.dispatch(`${GET_TEMPLATE_BY_COPY}`, {id: id}).then(data => {
        if (data && data.status === 1) {
          this.$toasted.success('Copied!', {
            duration: 1000,
            position: 'top-center'
          })
          this.params();
        }
      })
    },

    deleteItem(id) {
      confirm('Are you sure you want to delete ?') &&
      this.$store.dispatch(`${DELETE_TEMPLATE}`, id).then(data => {
        if (data && data.status === 1) {
          this.params();
        }
      })
    },
    addTemplate() {
      this.$router.push("/template_setting/templates/add_template")
    },
    addFont(id) {
      this.$router.push("/template_setting/templates/add_font_template/" + id)
    },
    redirectLink(template_size_id, theme_id) {
      return this.url_page + '/admin/editor/' + template_size_id + '/size/' + theme_id
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-add-templates {
  background-color: #71BEC8 !important;
  color: white !important;
  border-radius: 36px !important;
}

.btn__property {
  border: #71BEC8;
  border-radius: 36px;
  color: #71BEC8;
  margin-right: 20px;
  position: relative;
}

.v-progress-circular {
  margin: 1rem;
}
</style>
